import React, { type ReactElement, memo } from 'react';

import { SecondaryButton } from '@components/Button/variants';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

import { ProSecondaryButtonProps } from './interfaces';

const ProSecondaryButton = ({
  buttonText,
  clickText,
  url,
}: ProSecondaryButtonProps): ReactElement => {
  const { trackEvent } = useEventTracking();

  const handleEventTracking = () => {
    trackEvent(click({ clickTarget: ClickTarget.ProPerk, clickText, clickLink: url }));
  };

  return (
    <SecondaryButton
      as="link"
      className="mb-32 mt-32 border-pro-gold text-pro-gold hover:!bg-grayscale-beige focus:!bg-grayscale-beige active:!bg-grayscale-beige sm:mb-0"
      href={url}
      onClickCapture={handleEventTracking}
    >
      {buttonText}
    </SecondaryButton>
  );
};

export default memo(ProSecondaryButton);
